import React, { useState, useEffect } from "react";
import {
    Typography, Grid, InputBase, Button,
} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import useStyles from "./styles";
import { withSnackbar } from "../../../../../../components/Message/Alert";
import { ActionDialog } from "../../../../../../components/ActionDialog/ActionDialog";
import SearchGrid from "../../../../../../components/table/SearchGrid";
import AddNewProgram from "../grantHistory/components/reportIssue/ReportIssue";
import Authoization from "../grantHistory/components/authorization/Authorization";
import { PostDataAPI } from "../../../../../../Services/APIService";

import { SearchOutlined as SearchIcon } from "@material-ui/icons";




const CustomCard = ({ organizationId, ...props }) => {
    const classes = useStyles();
    const [addNewAddressDialog, setAddNewAddressDialog] = useState(false);
    const [authorization, setAuthorization] = useState(false);

    const { showMessage } = props;
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false,
        type: "confirm",
        message: "",
    });

    const [grantHistory, setGrantHistory] = useState([
        { allocatedProgram: 'Think Tank', description: 'A brief description of the purpose', grantAmount: '$ 1,300', date: 'Oct 01, 2023' },
        { allocatedProgram: 'Think Tank1', description: 'A brief description of the purpose', grantAmount: '$ 1,00', date: 'Oct 01, 2023' },
        { allocatedProgram: 'Think Tank2', description: 'A brief description of the purpose', grantAmount: '$ 1,100', date: 'Oct 01, 2023' },
        { allocatedProgram: 'Think Tank3', description: 'A brief description of the purpose', grantAmount: '$ 1,400', date: 'Oct 01, 2023' },
    ]);




    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState((prevState) => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback,
        }));
    };

    const closeAddAddress = () => {
        setAddNewAddressDialog(false);
    };

    const closeAutorization = () => {
        setAuthorization(false);
    };

    const handleSuccessClose = (message) => {
        closeAddAddress();
        showMessage("Success", message, "success", 3000);
    }
    const programModal = () => {
        setAddNewAddressDialog(true);
    };
    const programModal1 = () => {
        setAuthorization(true);
    };



    const [isDataRefresh, setIsDataRefresh] = useState(false);

    const handleDataRefresh = () => {
        setIsDataRefresh(!isDataRefresh);
    }
    const [grantReceived, setGrantReceived] = useState([]);

    const loadAllCollection = () => {
        var params = {
            donorId: organizationId
        }
        PostDataAPI("fdngrantcollection/loadGrid", params).then((result) => {
            console.log(result);
            if (result.success && result.data != null) {
                setGrantReceived(result.data)
                handleDataRefresh()
            } else {
                setGrantReceived([]);
            }
        });
    };


    useEffect(() => {
        loadAllCollection()
    }, []);

    return (
        <>
            <Grid container className={classes.gridHeader}>
                <Typography variant="h5" className={classes.GridHeading}>

                </Typography>
                {/* <div className={"HeaderDialog"}>
                    <div className={classes.gridActions}>
                        <Button className={classes.changeBtn} onClick={() => programModal()}>
                            <AddCircleOutlineIcon style={{ marginRight: "6px" }} /> Report Issue
                        </Button>
                    </div>
                  
                    <div className={classes.gridActions} style={{ marginRight: "7px" }}>
                        <InputBase
                            placeholder="Search"
                            className="grid-search-input"
                            startAdornment={<SearchIcon />}
                        />
                    </div>
                </div> */}
            </Grid>



            <Grid row className={classes.container}>
                <SearchGrid
                    columns="DonorGrantHistpry"
                    list={grantReceived}
                    noRecordMsg="No record exists."
                    Icon={true}
                    isUpdate={isDataRefresh}
                    isSearchAble={false}
                />
            </Grid>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
                onClose={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
            />
            {addNewAddressDialog ? (
                <AddNewProgram
                    dialogOpenClose={programModal}
                    handleClose={closeAddAddress}
                    handleSuccessClose={handleSuccessClose}
                ></AddNewProgram>
            ) : (
                ""
            )}

            {authorization ? (
                <Authoization
                    dialogOpenClose={programModal1}
                    handleClose={closeAutorization}
                    handleSuccessClose={handleSuccessClose}
                ></Authoization>
            ) : (
                ""
            )}

        </>
    );
};

export default withSnackbar(CustomCard);
